import type React from "react";
import {
  ButtonContainer,
  DebtAmount,
  DebtDescription,
  IconBarCode,
  DebtInfo,
  DebtItem,
  DebtList,
  ModalSubtitle,
  ModalTitle,
  StyledModal,
} from "./styles";
import { formatCurrency } from "utils";
import BarCode from "assets/images/icons/bar-code.svg";
import { Button } from "components";

interface DebtModalProps {
  open: boolean;
  debits: any[];
  onCancel: () => void;
  onRemoveAll: () => void;
}

export const ModalDeleteDebits: React.FC<DebtModalProps> = ({
  open,
  onCancel,
  onRemoveAll,
  debits = [],
}) => {
  return (
    <StyledModal
      title={null}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={520}
      centered
      closable={false}
      maskClosable={false}
    >
      <ModalTitle>Débitos vinculados!</ModalTitle>
      <ModalSubtitle>
        Outros débitos dependem desse, você pode cancelar essa remoção ou apagar
        todos.
      </ModalSubtitle>

      <DebtList>
        {debits
          .filter((debt) => debt?.name)
          .map((debt) => (
            <DebtItem key={debt.id_debit}>
              <IconBarCode src={BarCode} />
              <DebtInfo>
                <DebtDescription>{debt.name}</DebtDescription>
                <DebtAmount>{formatCurrency(debt.amount)}</DebtAmount>
              </DebtInfo>
            </DebtItem>
          ))}
      </DebtList>

      <ButtonContainer>
        <Button
          title="Remover todos"
          type_button="secondary"
          style={{ maxWidth: "fit-content" }}
          action={onRemoveAll}
        />
        <Button
          title="Cancelar"
          type_button="primary"
          style={{ maxWidth: "fit-content" }}
          action={onCancel}
        />
      </ButtonContainer>
    </StyledModal>
  );
};
